import { baseUrl } from "../../../../http-common";

const BASE = baseUrl+ "/dental";

async function http(method, url, body) {
  const res = await fetch(BASE + url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (res.status === 404) return null;
  if (!res.ok)
    throw new Error(`${method} ${url} -> ${res.status} ${await res.text()}`);
  return res.status === 204 ? null : res.json();
}
const enc = encodeURIComponent;

export const api = {
  // Masters
  fields: () => http("GET", "/masters/fields"),
  toothFindings: () => http("GET", "/masters/tooth-findings"),
  departments: () => http("GET", "/masters/departments"),

  // Field-wise templates
  listTemplates: (fieldKey) => http("GET", `/templates?fieldKey=${fieldKey}`),
  suggestTemplates: (fieldKey, q) =>
    http("GET", `/templates/suggest?fieldKey=${fieldKey}&q=${enc(q || "")}`),
  createTemplate: (t) => http("POST", "/templates", t),
  updateTemplate: (id, t) => http("PUT", `/templates/${id}`, t),
  deleteTemplate: (id) => http("DELETE", `/templates/${id}`),
  markTemplateUsed: (id) => http("POST", `/templates/${id}/use`),

  // Dental EMR
  saveEmr: (payload) => http("POST", "/dental-emr", payload),
  updateEmr: (id, payload) => http("PUT", `/dental-emr/${id}`, payload),
  emrForVisit: (patientId, visitId) =>
    http("GET", `/dental-emr/visit?patientId=${patientId}&visitId=${visitId}`),
  emrHistory: (patientId) =>
    http("GET", `/dental-emr/history?patientId=${patientId}`),
};
